class MiscHelper {
  static plaintext(text) {
    if (!text) {
      return ''
    }

    text = text.replace(/<!--[\s\S]*?-->/g, '');
    text = text.replace(/<[^>]*>/g, '');

    return text.trim();
  }

  static toBool(text) {
    text = this.plaintext(text);
    text = text.replace(/\n+/, '');
    let value = text.trim();

    if (value === '0') {
      return false;
    } else if (value === '1') {
      return true;
    }

    return value ? true : false;
  }
}

export default MiscHelper;
